import { formatDate } from '../../utils/dateUtils'

export const REFUND_TYPE = {
  PRICE_ADJUSTMENT: 3,
}

const toDateTimestamp = (value) => {
  if (!value) {
    return null
  }

  return value < 1e12 ? value * 1000 : value
}

const mapRefundLineItem = (item = {}) => ({
  title: item.productTitle,
  desc: item.variantTitle,
  quantity: item.quantity,
  price: item.price,
  discountPrice: item.discountPrice,
  displayOriginalPrice: item.displayMsrp,
  displayPrice: item.displayPrice,
  displayDiscountPrice: item.displayDiscountPrice,
  mainImage: {
    src: item.imageUrl,
    title: item.productTitle,
  }
})

const mapRefundRecord = (data = {}) => ({
  id: data.id,
  type: data.type,
  refundAmount: data.refundAmount,
  displayRefundAmount: data.displayRefundAmount,
  date: data.createAt ? formatDate(toDateTimestamp(data.createAt)) : '',
  itemsTotal: data.itemsTotal,
  displayItemsTotal: data.displayItemsTotal,
  refundShippingAmount: data.refundShippingAmount,
  displayShippingFee: data.displayRefundShippingAmount,
  salesTax: data.salesTax,
  displaySalesTax: data.displaySalesTax,
  reason: data.reason,
  lineItems: (data.items || []).map(mapRefundLineItem),
})

class OrderRefundDetailModel {
  constructor(data = {}) {
    Object.assign(this, {
      totalRefunded: data.totalRefunded,
      displayTotalRefunded: data.displayTotalRefunded,
      refundCount: data.refundCount,
      refunds: (data.refundHistory || []).map(mapRefundRecord),
    })
  }
}

export default OrderRefundDetailModel
